import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { AddNewRuleComponent } from '../../../add-new-rule/add-new-rule.component';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ApprovalRule } from 'src/app/Modules/settings/models/common/setting-area.model';
import { UntypedFormGroup } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-rules-sidebar',
    templateUrl: './rules-sidebar.component.html',
    styleUrls: ['./rules-sidebar.component.scss'],
    standalone: false
})
export class RulesSidebarComponent {
    @Input() rules: any;
    @Input() selectedRule: ApprovalRule;
    @Input() ruleconfigureForm: UntypedFormGroup;
    @Input() ruleValues: any;
    @Output() selectedRoleIdEmitter = new EventEmitter<any>();
    @Output() updateRuleNameEmitter = new EventEmitter<any>();
    @Output() deleteData = new EventEmitter<any>();
    @Output() refreshData = new EventEmitter<any>();
    tooltip_position = 'above';
    iscreateRule: boolean;
    iseditRule: boolean;
    isDeleteRolevisible: boolean;
    enabled: any;

    constructor(
        private modelService: NgbModal,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private toastrService: CustomToastService,
        private transLocoService: TranslocoService
    ) {}

    async ngOnInit(): Promise<void> {
        this.iseditRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Edit);
        this.isDeleteRolevisible = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Delete);
        this.iscreateRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Create);
    }

    selectedItem(item, isUpdate?: any) {
        if (item.approvalRuleId && item.approvalRuleId != '0' && this.rules.find((x) => !x.approvalRuleId || x.approvalRuleId == '0')) {
            this.globalEmittersService.RuleSaveDisable = true;
        } else {
            this.globalEmittersService.RuleSaveDisable = false;
        }
        let data: any = {
            item: item,
        };
        this.selectedRoleIdEmitter.emit(data);
    }
    addnewRule() {
        // this.refreshData.emit(true);
        let dialogRef = this.modelService.open(AddNewRuleComponent, {
            size: 'lg',
        });
        dialogRef.result
            .then((result: ApprovalRule) => {
                if (result) {
                    let item: ApprovalRule = {
                        approvalRuleId: result.approvalRuleId,
                        name: result.name,
                        enabled: true,
                    };
                    this.rules.push(item);
                    this.toastrService.successToast(
                        this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.NEW_RULE_ADDED_PLEASE_SAVE_TO_MAKE_THE_CHANGE')
                    );
                    this.selectedItem(item);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    editRule(item: ApprovalRule, event: MouseEvent) {
        event.stopPropagation(); // prevent parent click
        this.selectedItem(item);
        let dialogRef = this.modelService.open(AddNewRuleComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.selectedRule = item;
        dialogRef.result
            .then((result) => {
                if (result) {
                    // let datas = {
                    //     selectedData: result,
                    //     isUpdate: false, //Emit from edit Rule
                    // };
                    // this.updateRuleNameEmitter.emit(result);
                    // this.selectedItem(result);
                    // let datas = {
                    //     selectedData: result,
                    //     isUpdate: false, //Emit from edit Rule
                    // };
                    this.globalEmittersService.updateStatus.next(result);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    deleteRule(event: ApprovalRule, _event: MouseEvent) {
        _event.stopPropagation(); // prevent parent click
        let dialogRef = this.modelService.open(ConfirmationDialogComponent, {
            size: 'sm',
        });
        dialogRef.componentInstance.modalMessage = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_RULE');
        dialogRef.result
            .then((result) => {
                if (result === true) {
                    this.deleteData.emit(event);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    addDisabled() {
        return this.rules.find((x) => !x.approvalRuleId || x.approvalRuleId == '0') ? true : false;
    }
}
